// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { getSettingsCollection } from "@guestsupply/App/Store/Selectors/SettingsSelectors";
import { xValidation } from "@guestsupply/XDL/Utilities";
import { addToChainAfter, Handler, HasOnSuccess } from "@insite/client-framework/HandlerCreator";
import { AddressErrors } from "@insite/client-framework/Store/CommonHandlers/ValidateAddress";
import {
    chain,
    ValidateAddress,
} from "@insite/client-framework/Store/Pages/CheckoutShipping/Handlers/ValidateBillingAddressForm";
import {
    AddressFieldDisplayCollectionModel,
    BillToModel,
    CustomerValidationDto,
} from "@insite/client-framework/Types/ApiModels";

type HandlerType = Handler<
    {
        address: BillToModel;
        validation: CustomerValidationDto;
        fieldDisplay: AddressFieldDisplayCollectionModel;
    } & HasOnSuccess<boolean>,
    {
        formErrors: AddressErrors;
    }
>;
// XNG-CHANGES: Validate Address and Postalcode
export const XngValidateAddressAndPostalCode: HandlerType = props => {
    const isUsWebsite = getSettingsCollection(props.getState()).customSettings?.isUsWebSite;
    const address1Error = xValidation.address1(props.parameter.address.address1);
    const postalCodeError = xValidation.postalCode(props.parameter.address.postalCode, isUsWebsite);

    if (!props.formErrors.address1 && address1Error) {
        props.formErrors = {
            ...props.formErrors,
            address1: address1Error,
        };
    }
    if (!props.formErrors.postalCode && postalCodeError) {
        props.formErrors = {
            ...props.formErrors,
            postalCode: postalCodeError,
        };
    }
};

addToChainAfter(chain, ValidateAddress, XngValidateAddressAndPostalCode);
